module.exports = __webpack_public_path__ + "assets/comms_primary.2894fbdb.svg";